import { render, staticRenderFns } from "./SchoolHomeCommunicationList.vue?vue&type=template&id=1fe738d4&scoped=true"
import script from "./SchoolHomeCommunicationList.vue?vue&type=script&lang=js"
export * from "./SchoolHomeCommunicationList.vue?vue&type=script&lang=js"
import style0 from "./SchoolHomeCommunicationList.vue?vue&type=style&index=0&id=1fe738d4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe738d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe738d4')) {
      api.createRecord('1fe738d4', component.options)
    } else {
      api.reload('1fe738d4', component.options)
    }
    module.hot.accept("./SchoolHomeCommunicationList.vue?vue&type=template&id=1fe738d4&scoped=true", function () {
      api.rerender('1fe738d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolHomeCommunication/SchoolHomeCommunicationList.vue"
export default component.exports